

import * as homepageVideoActions from "./homePageVideo.action";

export const homepageVideoFeatureKey = "homepageVideoInfo";

const initialState = {
    loading: false,
    errorMsg: "",
    homepageVideoDetail: []
};

export const reducer = (state = initialState, { payload, type }) => {
    switch (type) {

        case homepageVideoActions.UPDATE_HOMEPAGE_VIDEO_REQUEST:
            return {
                ...state,
                loading: true
            }

        case homepageVideoActions.UPDATE_HOMEPAGE_VIDEO_SUCCESS:
            console.log(payload, 'payload')
            return {
                ...state,
                loading: false
            }       

        case homepageVideoActions.UPDATE_HOMEPAGE_VIDEO_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: payload
            }

        case homepageVideoActions.LIST_HOMEPAGE_VIDEO_REQUEST:
            return {
                ...state,
                loading: true
            }               

        case homepageVideoActions.LIST_HOMEPAGE_VIDEO_SUCCESS:
            return {
                ...state,
                loading: false,
                homepageVideoDetail: payload
            }

        case homepageVideoActions.LIST_HOMEPAGE_VIDEO_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: payload
            }

        default: return state;
    }
};